(()=>{
  const exactHandles=['gift-wrapping','gift-wrap','handwritten-message','handwritten-note','personal-message','artwork-frame','painting-frame','frame-option'];
  // Gift vouchers are intentionally storefront products and must remain visible
  // in Shop/collection results. This guard hides only service/add-on products;
  // View in Room has its own stricter artwork-eligibility rule.
  const handleFragments=[];
  const hrefRe=new RegExp('/products/([^/?#]+)','i');
  const selectors=['product-card','.resource-list__item','.predictive-search-results__card','.mega-menu__content-list-item','.resource-card__wrapper','.ja-recent__card','.ja-saved-card'];
  const isExcludedHandle=(handle)=> exactHandles.includes(handle) || handleFragments.some(fragment=>handle.includes(fragment));
  function removeLeaks(root=document){
    const links=[];
    if(root instanceof Element && root.matches('a[href*="/products/"]')) links.push(root);
    if(root.querySelectorAll) root.querySelectorAll('a[href*="/products/"]').forEach(a=>links.push(a));
    links.forEach(link=>{
      const href=link.getAttribute('href')||'';
      const match=href.match(hrefRe);
      const handle=(match && match[1] ? decodeURIComponent(match[1]) : '').toLowerCase();
      if(!isExcludedHandle(handle)) return;
      if(link.closest('cart-drawer,.cart-page,.cart-items,.ja-cart-addons')) return;
      const target=selectors.map(sel=>link.closest(sel)).find(Boolean);
      if(target) target.remove();
    });
  }
  document.addEventListener('DOMContentLoaded',()=>{
    removeLeaks(document);
    const observer=new MutationObserver(records=>{
      records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1) removeLeaks(node);}));
    });
    observer.observe(document.body,{childList:true,subtree:true});
  },{once:true});
})();
